import { Select, SelectProps } from "@shopify/polaris";
import { useEffect, useRef } from "react";

function FontsSelect(props: Omit<SelectProps, "options"> & { options: string[] }) {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (ref.current) {
            const options = Array.from(ref.current.querySelectorAll("option")) as HTMLOptionElement[];
            options.forEach((option) => {
                const font = option.value;
                option.style.fontFamily = font;
            });
        }
    }, [ref.current]);
    //ts-ignore sdsd
    const styledFonts: any = props.options.map((option) => {
        return { label: <span style={{ fontFamily: option }}>{option}</span>, value: option };
    });

    return (
        <div ref={ref}>
            <Select {...props} options={styledFonts} />
        </div>
    );
}

export default FontsSelect;
